import React from "react";
import { Link } from "react-router-dom";
import { site } from "../theme";

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#0F172A] text-white">
      {/* Slogan band */}
      <div className="bg-brand-bordo py-4">
        <div className="w-full px-6 xl:px-12 text-center">
          <p className="text-white/90 italic text-sm md:text-base">
            "Köklerine bağlı, yarına açık bir hemşehri dayanışması."
          </p>
        </div>
      </div>

      {/* Main footer */}
      <div className="w-full px-6 xl:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/Trabzonlular_transparency.png" alt="Bursa Trabzonlular Derneği" className="w-10 h-10 object-contain rounded-full bg-white p-0.5" />
              <div>
                <div className="font-bold text-sm">Bursa Trabzonlular</div>
                <div className="text-white/50 text-xs">Derneği</div>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Bursa'daki Trabzonluları aynı çatı altında buluşturan; kültürünü
              yaşatan, dayanışmayı güçlendiren bir hemşehri ocağı.
            </p>
            <div className="flex gap-2 mt-5">
              {[
                { icon: "fa-brands fa-instagram", label: "Instagram", href: "https://www.instagram.com/bursatrabzonlulardernegi/" },
                { icon: "fa-brands fa-whatsapp", label: "WhatsApp", href: "/" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target={s.href !== "/" ? "_blank" : undefined}
                  rel={s.href !== "/" ? "noopener noreferrer" : undefined}
                  aria-label={s.label}
                  className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-brand-bordo transition-colors text-sm"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Hızlı Erişim
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Hakkımızda", href: "/kurumsal/hakkimizda" },
                { label: "Etkinlik Takvimi", href: "/faaliyetler/etkinlikler" },
                { label: "Haberler", href: "/faaliyetler/haberler" },
                { label: "Gençlik", href: "/topluluk/genclik" },
                { label: "Burs / Sosyal Destek", href: "/destek/burs" },
                { label: "Galeri", href: "/medya/galeri" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="flex items-center gap-2 text-white/60 hover:text-white text-sm transition-colors"
                  >
                    <i className="fa-solid fa-angle-right text-[10px] text-brand-gold" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Topluluk
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Üyelik Başvurusu", href: "/destek/uyelik" },
                { label: "Gönüllü Ol", href: "/destek/gonulluluk" },
                { label: "Kadınlar ve Aile", href: "/topluluk/kadin-aile" },
                { label: "Öğrenciler", href: "/topluluk/ogrenciler" },
                { label: "Meslek Ağı", href: "/topluluk/meslek-agi" },
                { label: "Trabzon Kültürü", href: "/tarihce/kultur" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="flex items-center gap-2 text-white/60 hover:text-white text-sm transition-colors"
                  >
                    <i className="fa-solid fa-angle-right text-[10px] text-brand-gold" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              İletişim
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm text-white/60">
                <i className="fa-solid fa-location-dot mt-0.5 text-brand-gold" />
                <span>{site.address}</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/60">
                <i className="fa-solid fa-phone text-brand-gold" />
                <a href={`tel:${site.phone}`} className="hover:text-white">
                  {site.phone}
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/60">
                <i className="fa-solid fa-envelope text-brand-gold" />
                <a href={`mailto:${site.email}`} className="hover:text-white break-all">
                  {site.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/60">
                <i className="fa-brands fa-whatsapp text-brand-gold" />
                <a href="/" className="hover:text-white">WhatsApp Hattı</a>
              </li>
            </ul>

            <div className="mt-6">
              <Link
                to="/destek/uyelik"
                className="inline-flex items-center gap-2 bg-brand-bordo text-white text-sm font-semibold px-5 py-2.5 rounded-md hover:bg-brand-bordo-dark transition-colors"
              >
                <i className="fa-solid fa-user-plus text-xs" />
                Üyelik Başvurusu
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 py-4">
        <div className="w-full px-6 xl:px-12 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Bursa Trabzonlular Derneği. Tüm hakları saklıdır.</span>
          <div className="flex items-center gap-3">
            <Link to="/gizlilik" className="hover:text-white transition-colors">
              Gizlilik Politikası
            </Link>
            <span className="text-white/20">·</span>
            <span>{site.domain}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
